import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import StyledGrid from "../../../shared/components/StyledGrid";

import useFetchWithMsal from "../../../utils/useFetchWithMsal";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import { LoadingPanel } from "../../../shared/components/LoadingPanel";
import { useAddMemberHistoryNoteMutation, useGetPaginateHistoryMutation } from "../../../services/InsuranceService";
import { AddNotePopup } from "../../memberForm/popups/AddNotePopup";
import moment from "moment";


export const MemberHistoryTab = (props) => {

  const { naicCode, naicMemberRoleCheck, memberKey } = props;

  const memberHistoryColumns = [
    { field: 'userName', headerName: 'User', width: 200, editable: true },
    { field: 'dateOfChange', headerName: 'Date', width: 150, editable: true, valueGetter: (value) => moment(value).utc().format("MM/DD/YYYY")},
    // { field: 'memberKey', headerName: 'Member Key', width: 50, editable: true },
    { field: 'fieldName', headerName: 'Type', width: 100, editable: true },
    { field: 'oldValue', headerName: 'Description', width: 180, editable: true, flex: 1,
    renderCell: (params) => params?.row?.fieldName === 'Note' ? params?.row?.newValue : `"${params?.row?.oldValue || " "}" changed to "${params?.row?.newValue}"`, },
    // { field: 'newValue', headerName: 'New Value', width: 100, editable: true, flex: 1 },
    // { field: 'userId', headerName: 'User Id', width: 200, editable: true },
    // { field: 'changeType', headerName: 'Change Type', width: 100, editable: true},

    // { field: 'member', headerName: 'Member', width: 150, editable: true },
    // { field: 'user', headerName: 'User', width: 150, editable: true },
  ]; 

  const { skip } = useFetchWithMsal();

  const [addMemberHistoryNote, {}] = useAddMemberHistoryNoteMutation("", { skip });

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });
  const [totalCount, setTotalCount] = useState(0);

  const [sortingModel, setSortingModel] = useState();

  const [showAddNotePopup, setShowAddNotePopup] = useState(false);


  const [rowData, setRowData] = useState({});
  const [getPaginateHistory, { data, isLoading }] = useGetPaginateHistoryMutation("", { skip });

  const { memberName } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    fetchData()
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    sortingModel?.field,
    sortingModel?.sort,
    naicCode
  ]);

  useEffect(() => {
    if (!isLoading) {
      if (data?.totalCount !== totalCount) {
        setTotalCount(data?.totalCount);
      }
    }
  }, [isLoading]);

  const fetchData = (value) => {
    const body = {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      orderBy: sortingModel?.field || "",
      orderByDirection: sortingModel?.sort || "",
      naicCode: naicCode,
      memberName: value? value.memberName : memberName
    };
    getPaginateHistory(body);
  };
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleAddMemberHistoryNote = (body) => {
    addMemberHistoryNote(body)
    setTimeout(() => {
      fetchData();
    }, 500);
  }

  const onPopupClose = () => {
    setShowAddNotePopup(false);
  };

  return (
    <Box sx={{ height: "100%", width: "100%", margin: "0 auto 0 auto" }}>
      {isLoading && <LoadingPanel />}
      {naicMemberRoleCheck &&
        <Button
          variant="outlined"
          onClick={() => setShowAddNotePopup(!showAddNotePopup)}
          sx={{ marginBottom: "15px" }}
        >
          Add Note
        </Button>}
      <StyledGrid
        data={data?.items}
        width="100%"
        columns={memberHistoryColumns}
        rowCount={totalCount}
        onSortingModelChange={(model) => setSortingModel(model[0])}
        paginationModel={paginationModel}
        setPaginationModel={handlePaginationModelChange}
        // withMenu
      />
      <AddNotePopup
        open={showAddNotePopup}
        onClose={onPopupClose}
        memberKey={memberKey}
        handleAddMemberHistoryNote={handleAddMemberHistoryNote}
      />
    </Box>
  );
};
